import React from 'react';

import { createClassName } from 'utils/createClassName';

import './centeredLayoutStyles.scss';

type Props = {
  noOverlay?: boolean;
};

export const CenteredLayoutComponent: React.FC<Props> = (props) => {
  const { children, noOverlay } = props;

  const className = createClassName('centeredLayout')({ noOverlay });

  return <div className={className}>{children}</div>;
};
